import axios from 'axios';
import { updateUrlByParams } from 'utils/url';
import qs from 'qs';

// Setup api client
const apiClient = axios.create({
  baseURL: payload.services.searchservice.url
});

export default {
  async search(params, token = null) {
    const { urlParams } = updateUrlByParams(params);

    let config = {};
    if (token) {
      config = {
        headers: {
          Authorization: `Bearer ${token}`
        }
      };
    }

    const subEndpoint = params.tab === 'products' ? 'competitor-product' : 'competitor';

    return (await apiClient.post(`/api/v1/competitor-app/${subEndpoint}/search${urlParams}`, {}, config)).data;
  },

  async loadMore(from, subEndpoint, token = null) {
    let config = {};
    if (token) {
      config = {
        headers: {
          Authorization: `Bearer ${token}`
        }
      };
    }

    return (await apiClient.post(`/api/v1/competitor-app/${subEndpoint}/search${location.search}`, { from }, config)).data;
  },

  // TODO fetches only 10 results, do we need more?
  async productsByInternalProduct(prd, industry = null, token = null) {
    let config = {};
    if (token) {
      config = {
        headers: {
          Authorization: `Bearer ${token}`
        }
      };
    }

    const params = {
      prds: prd
    };

    if (industry) params.i = industry;

    return (await apiClient.post(
      `/api/v1/competitor-app/competitor-product/search?${qs.stringify(params, { arrayFormat: 'comma', encode: false })}`,
      {
        aggs: false
      },
      config
    )).data;
  }
};
